import { httpClientFunction } from 'domain/types';
import PresetForm from 'domain/entity/preset/form/presetForm';
import ReadPresetFormClient from 'use-case/presets/form/readPresetFormClient';
import ReadPresetFormCriteria from 'use-case/presets/form/readPresetFormCriteria';
import { deserializeResponse } from 'adapter/out/serializer';

export default (httpClient: httpClientFunction, baseUrl: string): ReadPresetFormClient => (criteria: ReadPresetFormCriteria) =>
    deserializeResponse(httpClient(`${baseUrl}/dashboards/presets/${criteria.preset}/form`, {}), PresetForm, (json) => ({
        ...(json as object),
        type: criteria.preset,
    }));
